export default __webpack_public_path__ + "static/media/prabesh.fa710abb.jpg";